import React from 'react';
import {Game, GameStatus, getStatusDisplay, getStatusClass} from './model/Game.ts';
import {Team} from './model/Team.ts';
import './GameCard.css';

interface GameCardProps {
    game: Game;
    homeTeam: Team;
    awayTeam: Team;
    onClick: () => void;
}

export default function GameCard({game, homeTeam, awayTeam, onClick}: GameCardProps) {
    const gameDate = new Date(game.startDate);
    const formattedDate = gameDate.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    });
    const formattedTime = gameDate.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit'
    });

    const isFinal = game.status === GameStatus.STATUS_FINAL;
    const homeWon = isFinal && game.homeScore > game.awayScore;
    const awayWon = isFinal && game.awayScore > game.homeScore;

    return (
        <div className="game-card" onClick={onClick}>
            <div className={`game-card-status ${getStatusClass(game.status)}`}>
                {getStatusDisplay(game.status)}
            </div>
            <div className="game-card-title">{game.gameName}</div>
            <div className="game-card-teams">
                <div className="team-section">
                    <img src={homeTeam.logo} alt={homeTeam.displayName} className="team-logo" />
                    <div className="team-info">
                        <span className="team-name">{homeTeam.shortDisplayName}</span>
                        <div className="score-container">
                            <span className="score">{game.homeScore}</span>
                            {homeWon && <span className="win-arrow">◀</span>}
                        </div>
                    </div>
                </div>
                <div className="vs-divider">vs</div>
                <div className="team-section">
                    <img src={awayTeam.logo} alt={awayTeam.displayName} className="team-logo" />
                    <div className="team-info">
                        <span className="team-name">{awayTeam.shortDisplayName}</span>
                        <div className="score-container">
                            {awayWon && <span className="win-arrow">▶</span>}
                            <span className="score">{game.awayScore}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="game-card-date">
                <div>{formattedDate}</div>
                <div>{formattedTime}</div>
            </div>
        </div>
    );
}
